"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SequencerInbox__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "firstMessageNum",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "beforeAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMessageCount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "totalDelayedMessagesRead",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32[2]",
                name: "afterAccAndDelayed",
                type: "bytes32[2]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "seqBatchIndex",
                type: "uint256",
            },
        ],
        name: "DelayedInboxForced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                indexed: false,
                internalType: "bool",
                name: "isSequencer",
                type: "bool",
            },
        ],
        name: "IsSequencerUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint256",
                name: "newMaxDelayBlocks",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMaxDelaySeconds",
                type: "uint256",
            },
        ],
        name: "MaxDelayUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "firstMessageNum",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "beforeAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMessageCount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "afterAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "bytes",
                name: "transactions",
                type: "bytes",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "lengths",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256[]",
                name: "sectionsMetadata",
                type: "uint256[]",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "seqBatchIndex",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "address",
                name: "sequencer",
                type: "address",
            },
        ],
        name: "SequencerBatchDelivered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "uint256",
                name: "firstMessageNum",
                type: "uint256",
            },
            {
                indexed: true,
                internalType: "bytes32",
                name: "beforeAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "newMessageCount",
                type: "uint256",
            },
            {
                indexed: false,
                internalType: "bytes32",
                name: "afterAcc",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "seqBatchIndex",
                type: "uint256",
            },
        ],
        name: "SequencerBatchDeliveredFromOrigin",
        type: "event",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "transactions",
                type: "bytes",
            },
            {
                internalType: "uint256[]",
                name: "lengths",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "sectionsMetadata",
                type: "uint256[]",
            },
            {
                internalType: "bytes32",
                name: "afterAcc",
                type: "bytes32",
            },
        ],
        name: "addSequencerL2Batch",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "transactions",
                type: "bytes",
            },
            {
                internalType: "uint256[]",
                name: "lengths",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "sectionsMetadata",
                type: "uint256[]",
            },
            {
                internalType: "bytes32",
                name: "afterAcc",
                type: "bytes32",
            },
        ],
        name: "addSequencerL2BatchFromOrigin",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "transactions",
                type: "bytes",
            },
            {
                internalType: "uint256[]",
                name: "lengths",
                type: "uint256[]",
            },
            {
                internalType: "uint256[]",
                name: "sectionsMetadata",
                type: "uint256[]",
            },
            {
                internalType: "bytes32",
                name: "afterAcc",
                type: "bytes32",
            },
            {
                internalType: "contract IGasRefunder",
                name: "gasRefunder",
                type: "address",
            },
        ],
        name: "addSequencerL2BatchFromOriginWithGasRefunder",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "delayedInbox",
        outputs: [
            {
                internalType: "contract IBridge",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_totalDelayedMessagesRead",
                type: "uint256",
            },
            {
                internalType: "uint8",
                name: "kind",
                type: "uint8",
            },
            {
                internalType: "uint256[2]",
                name: "l1BlockAndTimestamp",
                type: "uint256[2]",
            },
            {
                internalType: "uint256",
                name: "inboxSeqNum",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "gasPriceL1",
                type: "uint256",
            },
            {
                internalType: "address",
                name: "sender",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "messageDataHash",
                type: "bytes32",
            },
            {
                internalType: "bytes32",
                name: "delayedAcc",
                type: "bytes32",
            },
        ],
        name: "forceInclusion",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "getInboxAccsLength",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        name: "inboxAccs",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract IBridge",
                name: "_delayedInbox",
                type: "address",
            },
            {
                internalType: "address",
                name: "_sequencer",
                type: "address",
            },
            {
                internalType: "address",
                name: "_rollup",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "isMaster",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        name: "isSequencer",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxDelayBlocks",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "maxDelaySeconds",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "messageCount",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "postUpgradeInit",
        outputs: [],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "proof",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_messageCount",
                type: "uint256",
            },
        ],
        name: "proveBatchContainsSequenceNumber",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "proof",
                type: "bytes",
            },
            {
                internalType: "uint256",
                name: "_messageCount",
                type: "uint256",
            },
        ],
        name: "proveInboxContainsMessage",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rollup",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "sequencer",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "addr",
                type: "address",
            },
            {
                internalType: "bool",
                name: "newIsSequencer",
                type: "bool",
            },
        ],
        name: "setIsSequencer",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "newMaxDelayBlocks",
                type: "uint256",
            },
            {
                internalType: "uint256",
                name: "newMaxDelaySeconds",
                type: "uint256",
            },
        ],
        name: "setMaxDelay",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "totalDelayedMessagesRead",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SequencerInbox__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
        this.contractName = "SequencerInbox";
    }
    deploy(overrides) {
        return super.deploy(overrides || {});
    }
    getDeployTransaction(overrides) {
        return super.getDeployTransaction(overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SequencerInbox__factory = SequencerInbox__factory;
SequencerInbox__factory.bytecode = _bytecode;
SequencerInbox__factory.abi = _abi;
